import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { esSesionDemo, marcaSesionDemo, urlRegistroDesdeDemo } from '../../utils/demo';
import DemoLeadModal from './DemoLeadModal';

/**
 * Barra fija de la demostración.
 *
 * Dice tres cosas y no más: que esto son datos de ejemplo, que lo que toque se
 * borra cada hora, y por dónde se sale a tener una cuenta de verdad. Sin esto,
 * quien entre desde un enlace no sabe si está viendo una demo o la aplicación
 * de otra persona.
 */
export default function DemoBanner() {
  const { user, logout } = useAuth();
  const [abierto, setAbierto] = useState(false);

  // Doble comprobación: el flag del servidor manda, el de sesión cubre la
  // recarga antes de que el usuario se haya rehidratado del backend.
  const enDemo = Boolean((user as { isDemo?: boolean } | null)?.isDemo) || esSesionDemo();
  if (!enDemo) return null;

  const salirACrearCuenta = () => {
    const destino = urlRegistroDesdeDemo();
    marcaSesionDemo(false);
    logout();
    window.location.href = destino;
  };

  return (
    <>
      <div className="sticky top-0 z-50 bg-blue-600 text-white">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-x-4 gap-y-2 px-4 py-2 text-sm">
          <span className="font-medium">Estás en la demostración</span>
          <span className="hidden text-blue-100 sm:inline">
            Datos de ejemplo de una guía en Sevilla. Lo que cambies se reinicia cada hora.
          </span>

          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => setAbierto(true)}
              className="rounded-md bg-white/15 px-3 py-1 font-medium text-white transition hover:bg-white/25"
            >
              Que me llamen
            </button>
            <button
              type="button"
              onClick={salirACrearCuenta}
              className="rounded-md bg-white px-3 py-1 font-medium text-blue-700 transition hover:bg-blue-50"
            >
              Crear mi cuenta
            </button>
          </div>
        </div>
      </div>

      <DemoLeadModal abierto={abierto} onCerrar={() => setAbierto(false)} origen="demo-banner" />
    </>
  );
}
